// extracted by mini-css-extract-plugin
export default {"card":"ScoreCard-module__card__7Uy-H","content":"ScoreCard-module__content__VfRtd","score":"ScoreCard-module__score__DTs6J","average":"ScoreCard-module__average__g9Gx6"};